import Box from '@mui/material/Box';
import Background from '@/common/Background';
import BlurBox from '@/common/BlurBox';
import Typography from '@mui/material/Typography';
import CustomCarousel from './FindBatchCodeSlider';
import { useNavigate } from '@tanstack/react-router';
import PrimaryButton from '@/common/PrimaryButton';

const css = {
  title: {
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '1.65rem',
    textAlign: 'center',
  },
  text: { color: '#FFF', textAlign: 'center', mb: 2, padding: '7px' },
  blurBox: { mb: 2 },
};

const FindBatchCode = () => {
  const navigate = useNavigate();
  const handleBackHomeClick = () => navigate({ to: '/' });

  return (
    <Background bg={'bg.webp'}>
      <BlurBox sx={css.blurBox}>
        <Typography variant="h2" sx={css.title}>
          ¿Dónde encontrar el lote en el empaque?
        </Typography>

        {/* carousel component */}
        <CustomCarousel />
        <Box mt={2} alignItems="center">
          <Typography sx={css.text}>
            Recuerda: Algunas presentaciones tienen el código ubicado en la parte trasera del
            empaque.
          </Typography>
        </Box>
      </BlurBox>

      {/* Back button */}
      <PrimaryButton text={'Volver al inicio'} onClick={handleBackHomeClick} />
    </Background>
  );
};
export default FindBatchCode;
